import React from 'react';
import { Outlet } from 'react-router-dom';
import { Page, PageProps } from './Page';
import { TabBar, TabBarItem } from './TabBar';

export interface MobileLayoutProps {
  /**
   * TabBar 配置（不提供则不显示 TabBar）
   */
  tabBar?: {
    items: TabBarItem[];
    activeColor?: string;
    inactiveColor?: string;
  };
  /**
   * Page 组件的额外属性
   */
  pageProps?: Omit<PageProps, 'children' | 'hasTabBar' | 'hasNavBar'>;
  /**
   * 自定义内容（不使用 Outlet）
   */
  children?: React.ReactNode;
}

/**
 * 移动端布局组件
 *
 * 整合了 Page、TabBar；顶部导航由各页面自行渲染 `NavBar`。
 */
export function MobileLayout({ tabBar, pageProps, children }: MobileLayoutProps) {
  return (
    <>
      <Page hasTabBar={!!tabBar} hasNavBar={false} {...pageProps}>
        {children || <Outlet />}
      </Page>

      {tabBar && <TabBar {...tabBar} />}
    </>
  );
}
